import { isIsolatedCloud } from '@atlaskit/atlassian-context/perimeter';

import { createResource } from '@townsquare/router/resources/createResource';
import type { ResourceContext } from '@townsquare/router/types';

type DashboardExperienceResponse = {
	isOptedIn: boolean;
	isOptedInToAi: boolean;
};
export const dashboardExperienceResource = createResource<DashboardExperienceResponse>({
	type: 'DASHBOARD_EXPERIENCE_STATUS',
	getKey: (_, resourceContext) => {
		if (isIsolatedCloud()) {
			return 'ISOLATED_CLOUD';
		}
		const { workspace } = resourceContext as ResourceContext;
		if (!workspace) {
			// "no workspace" is a valid customer experience
			return 'NO_WORKSPACE';
		}
		const { activationId, cloudId } = workspace;
		return JSON.stringify({ activationId, cloudId });
	},
	getData: async (_, resourceContext) => {
		if (isIsolatedCloud()) {
			return {
				isOptedIn: false,
				isOptedInToAi: false,
			};
		}
		const { workspace } = resourceContext as ResourceContext;
		if (!workspace) {
			// "no workspace" is a valid customer experience
			return {
				isOptedIn: false,
				isOptedInToAi: false,
			};
		}
		const { activationId, cloudId } = workspace;
		const response = await fetch(
			`/gateway/api/avp-platform/cloudId/${cloudId}/workspaceId/${activationId}/dashboard-experience-status`,
		);
		if (!response.ok) {
			return {
				isOptedIn: false,
				isOptedInToAi: false,
			};
		}
		const data = await response.json();
		return {
			isOptedIn: data.isOptedIn ?? false,
			isOptedInToAi: data.isOptedInToAi ?? false,
		};
	},
	maxAge: 60_000 * 5,
});
